import { Injectable } from '@angular/core';
import { EparcoursPath } from '../../constantes/menu/menu-items/eparcours-path';
import { NavService } from './nav-service';
import { Navigator, NavigatorWith2Params, NavigatorWithParam, PARAM_TOKEN } from './navigators/navigators';

@Injectable({
  providedIn: 'root',
})
export class SessionsNavService extends NavService {
  general: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.EDITION_GENERAL,
  );


  contratsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.CONTRATS,
  );

  creation_contrat = this.makeNavigatorWith2Params<number,number>(
    EparcoursPath.root.SESSIONS,
    PARAM_TOKEN,
    EparcoursPath.sessions.CREATION_CONTRAT,
    PARAM_TOKEN,
  );

  edition_contrat = this.makeNavigatorWith2Params<number,number>(
    EparcoursPath.root.SESSIONS,
    PARAM_TOKEN,
    EparcoursPath.sessions.EDITION_CONTRAT,
    PARAM_TOKEN,
  );

  edition_root: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
  );

  creation: Navigator = this.makeNavigator(EparcoursPath.root.SESSIONS, EparcoursPath.sessions.CREATION);

  creationPourIdFormation: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.CREATION,
    PARAM_TOKEN,
  );

  recherche: Navigator = this.makeNavigator(EparcoursPath.root.SESSIONS);

  inscriptionsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.LISTE_INSCRIPTIONS,
  );

  seancesByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.LISTE_SEANCES,
  );

  documentsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.DOCUMENTS,
  );

  facturesByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.FACTURES,
  );

  tarifsByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.TARIFS,
  );
  creation_seance: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.CREATION_SEANCE,
  );
  edition_seance: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.EDITION_SEANCE,
    PARAM_TOKEN,
  );
  creation_inscription: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.CREATION_INSCRIPTION,
  );
  creation_multi_inscription: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.CREATION_MULTI_INSCRIPTION,
  );

  edition_facture_brouillon: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.FACTURES,
    EparcoursPath.sessions.EDITION_BROUILLON_FACTURE,
    PARAM_TOKEN,
  );

  visualise_facture_validee: NavigatorWith2Params<number, number> = this.makeNavigatorWith2Params<number, number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.FACTURES,
    EparcoursPath.sessions.VISUALISE_FACTURE,
    PARAM_TOKEN,
  );

  resumeByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.RESUME_SESSION,
  );

  budgetByIdSession: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.SESSIONS,
    EparcoursPath.sessions.EDITION,
    PARAM_TOKEN,
    EparcoursPath.sessions.BUDGET,
  );
}
